import React from 'react';
import ReactDOM from 'react-dom';
import "./config/i18next-config";
import App from './App';
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
